<template>
    <div ref="pageView" class="page-view container-view">
        <!-- title -->
        <section class="title-section fixed-view">
            <e6-title>
                {{pageTitle}}
                <template slot="breadcrumb">
                    <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
                </template>
            </e6-title>
        </section>
        <!-- title end -->
        <!-- content -->
        <section class="content-section" :style="{height: resizeViewHeight + 'px'}">
            <div class="form-wrapper">
                <e6-form-extend
                        class="e6-from--column-2"
                        ref="formExtend"
                        :formExtend="formExtend"
                        :inline="true"
                        label-width="200px"
                        @submitForm="handleSubmitForm"
                        @resetForm="handleResetForm">
                    <template slot-scope="slotForms">
                        <el-form-item prop="forms.appKey" label="appKey" :rules="validatorAppKey">
                            <el-input v-model="slotForms.forms.appKey" placeholder="appKey" :disabled="true"
                                      clearable></el-input>
                        </el-form-item>

                        <el-form-item prop="forms.appSecret" label="appSecret" :rules="validatorAppSecret">
                            <el-input v-model="slotForms.forms.appSecret" placeholder="appSecret" :disabled="true"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item label="用户类型"
                                      prop="forms.useType"
                                      :rules="[
                { required: true, message: '用户类型必填', trigger: 'change' }
              ]"
                        >
                            <el-radio-group v-model="slotForms.forms.useType">
                                <el-radio :label="1">服务商</el-radio>
                                <el-radio :label="2">企业</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item
                                prop="forms.corpId"
                                label="企业名称"
                                :rules="[{ required: true, message: '请选择企业', trigger: 'change' }]">
                            <el-select v-model="slotForms.forms.corpId" placeholder="请选择" filterable filterable>
                                <el-option v-for="item in allCustomer" :key="item.value" :label="item.label"
                                           :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>

                        <div class="form-wrapper">
                            <el-row>
                                <el-col :span="14" :offset="5">
                                    <el-transfer class="myTransfer" filterable filter-placeholder="请输入接口名称"
                                                 v-model="slotForms.forms.interfaceIdList"
                                                 :props="{key: 'interfaceId', label: 'interfaceName' }"
                                                 :titles="['未添加', '已添加']" :data="allInterfaceData">
                                    </el-transfer>
                                </el-col>
                            </el-row>
                        </div>
                    </template>
                    <template slot="submit">保存</template>
                    <template slot="reset">返回</template>
                </e6-form-extend>
            </div>
        </section>
        <!-- content end -->
    </div>
</template>

<script>
    import {
        FetchAllCustomer,
        FetchAllInterfaceInfo,
        FetchInterfaceUserInfoByAppId,
        SaveInterfaceUserInfo
    } from "@/api/systemSetting/interfaceUserManager";
    import {mapGetters} from "vuex";
    import resizeListener from "_private/mixins/resizeListener";
    import {mergeFormExtend} from "_private/utils/merge";
    import {validatorIP, validatorIntNum} from '@/utils/validation.js';

    export default {
        mixins: [resizeListener],
        data: function () {
            return {
                allInterfaceData: [],
                allCustomer: [],
                breadcrumbs: [
                    {
                        path: "/systemSettingInterfaceUserManagerList",
                        isRedirect: true,
                        meta: {
                            title: "接口用户管理"
                        }
                    }
                ],
                formExtend: {
                    forms: {},
                    extends: []
                },
            };
        },
        computed: {
            ...mapGetters(["moduleId"]),
            pageType() {
                return this.$route.query.pageType ? this.$route.query.pageType : "1";
            },
            pageTitle() {
                const pageTitle = this.pageType === "1" ? "新增用户接口" : "修改用户接口";
                return pageTitle;
            },
            appId() {
                return this.$route.query.appId;
            },
            userNickName() {
                return this.allCustomer.find(t => t.value == this.formExtend.forms.corpId).label;
            },
            validatorAppKey() {
                return [
                    {required: true, message: 'appKey不能为空', trigger: ['blur']}
                ];
            },
            validatorAppSecret() {
                return [
                    {required: true, message: 'appSecret不能为空', trigger: ['blur']}
                ];
            },
            validatorIP() {
                return [
                    {required: false, message: 'IP不能为空', trigger: ['blur']},
                    {validator: validatorIP, trigger: ['blur']},
                ];
            },
            validatorBusinessId() {
                return [
                    {required: false, message: '业务ID不能为空', trigger: ['blur']},
                    {validator: validatorIntNum, trigger: ['blur']},
                ];
            }
        },
        created() {
            let breadcrumb = {
                path: "/baseDataInterfaceUserManagerEdit",
                isRedirect: false,
                meta: {
                    title: this.pageTitle
                }
            };
            this.breadcrumbs.push(breadcrumb);
            this.initAllCustomer();
            this.initAllInterfaceInfo();
            if (this.pageType === "2") {
                this.FetchInterfaceUserInfoByAppId({appId: this.appId});
            } else {
                //生成新的appKey、appSecret
                this.formExtend.forms.appKey = this.createUUid();
                this.formExtend.forms.appSecret = this.createUUid();
            }
        },
        methods: {
            /**
             *  初始化客户信息
             */
            initAllCustomer() {
                FetchAllCustomer()
                    .then(response => {
                        if (response.result && response.result && Array.isArray(response.result)) {
                            this.allCustomer = response.result;
                        }
                    }).catch(error => {
                    console.log(error);
                });
            },
            //初始化所有接口信息
            initAllInterfaceInfo() {
                FetchAllInterfaceInfo()
                    .then(response => {
                        if (response.result && response.result && Array.isArray(response.result)) {
                            this.allInterfaceData = response.result;
                        }
                    }).catch(error => {
                    console.log(error);
                });
            },
            // 修改时，先获取信息
            FetchInterfaceUserInfoByAppId(data) {
                FetchInterfaceUserInfoByAppId(data)
                    .then(response => {
                        this.formExtend.forms = Object.assign({}, response.result);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // 新增，修改
            SaveInterfaceUserInfo(data) {
                SaveInterfaceUserInfo(data)
                    .then(response => {
                        this.submitCallback(response);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // 新增、修改完成时的回调函数
            submitCallback(data) {
                let type = data.code === 1 ? "success" : "error";
                let message = data.message;
                this.$message({
                    showClose: true,
                    message: message,
                    type: type,
                    duration: 2000,
                    onClose: () => {
                        if (type === "success") {
                            this.$router.push("/systemSettingInterfaceUserManagerList");
                        }
                    }
                });
            },
            // 提交
            handleSubmitForm(valid) {
                if (valid) {
                    let data = {};
                    // if (this.pageType === "1") {
                    //     data = mergeFormExtend(this.formExtend);
                    // } else {
                    //     data = Object.assign(mergeFormExtend(this.formExtend), {
                    //         appId: this.appId
                    //     });
                    // }
                    data = Object.assign(mergeFormExtend(this.formExtend), {
                        userNickName: this.userNickName
                    });
                    this.SaveInterfaceUserInfo(data);
                }
            },
            // 取消
            handleResetForm() {
                this.$router.push("/systemSettingInterfaceUserManagerList");
            },
            //生成uuid
            createUUid() {
                //生成32位UUID
                let s = [];
                let hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                return uuid;
            }
        }
    };
</script>
<style lang="scss" scoped>
    .page-view {
        height: 100%;
    }

    .title-section {
        padding: 15px 20px 10px;
    }

    .content-section {
        overflow: auto;
    }

    .content-section {
        .form-wrapper {
            padding-top: 20px;
            margin: 0 20px;
            background-color: #fff;
        }
    }

    /deep/ .e6-from--column-2 {
        .el-input {
            width: 240px;
        }
        .el-textarea__inner {
            width: 240px;
        }
    }

    .myTransfer /deep/ .el-transfer-panel {
        width: 270px !important;
        min-height: 370px;
    }

    .myTransfer /deep/ .el-transfer-panel .el-transfer-panel__list {
        height: 100%;
    }

</style>